import { render } from "./ClaimsHistory.vue?vue&type=template&id=875e3330&scoped=true&ts=true"
import script from "./ClaimsHistory.vue?vue&type=script&lang=ts"
export * from "./ClaimsHistory.vue?vue&type=script&lang=ts"

import "./ClaimsHistory.vue?vue&type=style&index=0&id=875e3330&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-875e3330"]])

export default __exports__